import axiosClient from "../api/axiosClient";

export type CreateTransactionPayload = {
  schedule_id: number | string;
  loan_id: number |string;
  amount_paid: number;
  payment_mode: "Cash" | "Card" | "Bank" | string;
  reference_number?: string | null;
  payment_on?: string; 
};

export type CreateTransactionResponse = {
  schedule?: any;
  transaction?: any;
  transaction_id?:any;
};


export async function createTransaction(
  payload: CreateTransactionPayload
): Promise<CreateTransactionResponse> {
  const resp = await axiosClient.post("/transactions", payload);
  return resp.data;
}


export async function getpendings() {
  const res = await axiosClient.get("/due-summary")
  return res.data
  
}
export async function getPendingsByDateRange(fromDate: string, toDate: string) {
  const res = await axiosClient.get("/due-summary", {
    params: {
      from_date: fromDate,
      to_date: toDate
    }
  })
  return res.data
}
// Penalty

export async function getPenalty(payload: { loan_id: string; schedule_id: string }) {
  const res = await axiosClient.post("/penalty/calculate", payload);
  return res.data;
}

export const adjustPenalty = async (penaltyId: number | string, body: any) => {
  return axiosClient.put(`/penalty/adjust/${penaltyId}`, body).then(res => res.data);
};

export const markPenaltyPaid = async (penaltyId: number | string) => {
  return axiosClient.put(`/penalty/mark-paid/${penaltyId}`).then(res => res.data);
};


export async function getAllPenalty(params?: { from_date?: string; to_date?: string }) {
  // axios supports sending query params via 'params' option
  const res = await axiosClient.get("/penalty/list", { params });
  return res.data;
}

export async function getTotalAmountPenalty(params?: { from_date?: string; to_date?: string }) {
  const res = await axiosClient.get("/penalty/total-collected", { params });
  return res.data;
}

